// Import apisauce
import { create } from 'apisauce';

// our "constructor"
export const createAPI = (baseURL = process.env.REACT_APP_VERITAS_API_URL) => {
    // ------
    // STEP 1
    // ------
    //
    // Create and configure an apisauce-based api object.
    //
    const api = create({
        baseURL, // Use the provided baseURL or default from env variable
        headers: {
            "Cache-Control": "no-cache",
        },
        timeout: 20000, // 20-second timeout
    });

    // Add request interceptor to automatically add auth headers
    api.addRequestTransform((request) => {
        const token = localStorage.getItem("token");
        if (token) {
            request.headers.Authorization = `Bearer ${token}`;
        }
    });

    // Add response interceptor to handle 401 errors globally
    api.addResponseTransform((response) => {
        if (response.status === 401) {
                        // Dispatch global event for 401 handling
            window.dispatchEvent(new CustomEvent('auth:unauthorized', {
                detail: { response }
            }));
        }
    });

    const me = () => {
        return api.post('/api/verifyToken');
    };

    const signUp = (data) => {
                return api.post('/api/user/signup', data);
    };

    const sendInvite = (data) => {
        return api.post('/api/invite', data);
    };

    const getOrganizations = (acctId) => {
        return api.get(`/api/organization/all/${acctId}`);
    };

    const getOrganizationInvites = (acctId) => {
        return api.get(`/api/organization/invites/${acctId}`);
    };

    const getTeam = (orgid) => {
        return api.get(`/api/organization/team/${orgid}`);
    };

    const getTeamInvites = (orgid) => {
        return api.get(`/api/organization/team/invites/${orgid}`);
    };

    const getFilesByOrg = (orgid) => {
        return api.get(`/api/file/org/${orgid}`);
    };

    const queryFiles = (query) => {
        return api.post(`/api/file/query`, query);
    };

    const lookupCodes = (codes) => {
        return api.get(`/api/code/lookup/${codes}`);
    };

  

    const processFile = (data) => {
        return api.post(`/api/file/process`, data);
    };

    const processBulkReprice = (data) => {
        return api.post(`/api/file/processBulkRepirce`, data, {
            timeout: 0,
        });
    };

    const getFileBySlug = (slug) => {
        return api.get(`/api/file/slug/${slug}`);
    };
    
    const getNonce = (wa) => {
        return api.get('/api/nonce');
    };

    const getInviteCodeLookup = (code) => {
        return api.get(`/api/user/invite/${code}`);
    };

    const logIn = (data) => {
        return api.post('/api/login', data);
    };

    const deleteOrg = (orgid) => {
        return api.delete(`/api/organization/${orgid}`);
    };

    const updateOrgDetails = (data) => {
        return api.post(`/api/organization/${data.id}`, data);
    };

    const getAccounts = (accountIdArray) => {
        return api.get('/api/account/all', {
            accountIdArray: accountIdArray
        });
    };

    const getOrganizationByAccountId = (data) => {
        return api.get('/api/organization/getOrgByAccountsId');
    };

    const updateMarkup = (accountId, markup) => {
        return api.post('/api/account/updateMarkup', {
            accountId,
            markup
        });
    };

    const createEmpGrp = (data) => {
        return api.post('/api/organization', data);
    };

    const getGlobalContracts = ({ prefix = '*', offset = 0 } = {}) => {
        return api.post('/api/contract/getGlobalContracts', {
            prefix: prefix || '*',
            offset
        });
    };



    // Export the API client
    return {
        me,
        logIn,
        signUp,
        sendInvite,
        getOrganizations,
        getOrganizationInvites,
        getTeam,
        getTeamInvites,
        getNonce,
        getInviteCodeLookup,
        getFilesByOrg,
        queryFiles,
        getFileBySlug,
        lookupCodes,
        processFile,
        processBulkReprice,
        deleteOrg,
        updateOrgDetails,
        getAccounts,
        getOrganizationByAccountId,
        updateMarkup,
        createEmpGrp,
        getGlobalContracts,
        api // Export the api instance for direct access if needed
    };
};

// Creates a singleton
export const client = createAPI();
